import {moment} from "@/src/modules/core/lib";

/** Calendar days inside [first..last] day span that are not present in `days` (same rule as get-safelisting-form-default-values). */
export function getExcludedCalendarDatesFromDays(days: {date: string}[]): string[] {
  if (!days?.length) return [];
  const sorted = [...days].sort((a, b) => a.date.localeCompare(b.date));
  const dayDatesSet = new Set(days.map((d) => d.date));
  const excluded: string[] = [];
  const cursor = moment(sorted[0]!.date);
  const end = moment(sorted[sorted.length - 1]!.date);
  while (cursor.isSameOrBefore(end, "day")) {
    const dateStr = cursor.format("YYYY-MM-DD");
    if (!dayDatesSet.has(dateStr)) excluded.push(dateStr);
    cursor.add(1, "day");
  }
  return excluded;
}
